import 'material-design-icons-iconfont/dist/material-design-icons.css'
import Vue from 'vue'
import './plugins/vuetify'
import App from './App.vue'
import axios from 'axios'
import router from './router'
import store from './store'
import moment from 'moment'
import wysiwyg from 'vue-wysiwyg'
import uniq from 'lodash/uniq'

Vue.prototype.$vuetify.theme = {
  primary: process.env.VUE_APP_COLOR_PRIMARY,
  secondary: process.env.VUE_APP_COLOR_SECONDARY,
  accent: process.env.VUE_APP_COLOR_ACCENT,
  error: '#f44336',
  warning: '#ffeb3b',
  info: '#2196f3',
  success: '#4caf50'
}

Vue.use(wysiwyg, { hideModules: { 'image': true, 'removeFormat': true, 'separator': true }, forcePlainTextOnPaste: true, maxHeight: '500px' })

axios.defaults.headers.common['X-API-KEY'] = 'S98DH6DFGJ609'

const token = localStorage.getItem('user-token')
if (token) {
  axios.defaults.headers.common['Authorization'] = 'Bearer ' + token
}

Vue.config.productionTip = false

moment.locale('us')

window.$ = window.jQuery = require('jquery')

Vue.mixin({
  data () {
    return {
      originCities: [
        {
          name: 'China - Shenzhen',
          cityId: 'CN-SHENZHEN',
          countryId: 'CHN'
        },
        {
          name: 'Malaysia - Seremban',
          cityId: 'MY-SEREMBAN',
          countryId: 'MYS'
        },
        {
          name: 'Malaysia - KL',
          cityId: 'MY-KUALALUMPUR',
          countryId: 'MYS'
        },
        {
          name: 'Indonesia - Jakarta',
          cityId: 'ID-JAKARTAPUSAT',
          countryId: 'IDN'
        },
        {
          name: 'India - Ranchi',
          cityId: 'IN-RANCHI',
          countryId: 'IND'
        },
        {
          name: 'Pakistan - Hyderabad',
          cityId: 'PK-HYDERABAD',
          countryId: 'PAK'
        }
      ],
      titles: [
        'Mr',
        'Ms'
      ],
      timezones: [
        '+00:00',
        '+01:00',
        '+02:00',
        '+03:00',
        '+03:30',
        '+04:00',
        '+04:30',
        '+05:00',
        '+05:30',
        '+05:45',
        '+06:00',
        '+06:30',
        '+07:00',
        '+08:00',
        '+08:45',
        '+09:00',
        '+09:30',
        '+10:00',
        '+10:30',
        '+11:00',
        '+12:00',
        '+12:45',
        '+13:00',
        '+14:00',
        '-01:00',
        '-02:00',
        '-03:00',
        '-03:30',
        '-04:00',
        '-05:00',
        '-06:00',
        '-07:00',
        '-08:00',
        '-09:00',
        '-09:30',
        '-10:00',
        '-11:00',
        '-12:00'
      ],
      months: [
        {
          name: 'January',
          value: 1
        },
        {
          name: 'February',
          value: 2
        },
        {
          name: 'March',
          value: 3
        },
        {
          name: 'April',
          value: 4
        },
        {
          name: 'May',
          value: 5
        },
        {
          name: 'June',
          value: 6
        },
        {
          name: 'July',
          value: 7
        },
        {
          name: 'August',
          value: 8
        },
        {
          name: 'September',
          value: 9
        },
        {
          name: 'October',
          value: 10
        },
        {
          name: 'November',
          value: 11
        },
        {
          name: 'December',
          value: 12
        }
      ],
      taxDeclarePercentages: [
        {
          caption: '100%',
          value: 100
        },
        {
          caption: '95%',
          value: 95
        },
        {
          caption: '90%',
          value: 90
        },
        {
          caption: '85%',
          value: 85
        },
        {
          caption: '80%',
          value: 80
        },
        {
          caption: '75%',
          value: 75
        },
        {
          caption: '70%',
          value: 70
        },
        {
          caption: '65%',
          value: 65
        },
        {
          caption: '60%',
          value: 60
        },
        {
          caption: '55%',
          value: 55
        },
        {
          caption: '50%',
          value: 50
        },
        {
          caption: '45%',
          value: 45
        },
        {
          caption: '40%',
          value: 40
        },
        {
          caption: '35%',
          value: 35
        },
        {
          caption: '30%',
          value: 30
        },
        {
          caption: '25%',
          value: 25
        },
        {
          caption: '20%',
          value: 20
        },
        {
          caption: '15%',
          value: 15
        },
        {
          caption: '10%',
          value: 10
        },
        {
          caption: '5%',
          value: 5
        },
        {
          caption: '0%',
          value: 0
        }
      ]
    }
  },
  methods: {
    getImageDataAndSetOrientation: function (file, callback2) {
      var callback = function (srcOrientation) {
        var reader2 = new FileReader()
        reader2.onload = function (e) {
          var srcBase64 = e.target.result
          var img = new Image()

          img.onload = function () {
            var width = img.width
            var height = img.height
            var canvas = document.createElement('canvas')
            var ctx = canvas.getContext('2d')

            // set proper canvas dimensions before transform & export
            if (srcOrientation > 4 && srcOrientation < 9) {
              canvas.width = height
              canvas.height = width
            } else {
              canvas.width = width
              canvas.height = height
            }

            // transform context before drawing image
            switch (srcOrientation) {
              case 2: ctx.transform(-1, 0, 0, 1, width, 0); break
              case 3: ctx.transform(-1, 0, 0, -1, width, height); break
              case 4: ctx.transform(1, 0, 0, -1, 0, height); break
              case 5: ctx.transform(0, 1, 1, 0, 0, 0); break
              case 6: ctx.transform(0, 1, -1, 0, height, 0); break
              case 7: ctx.transform(0, -1, -1, 0, height, width); break
              case 8: ctx.transform(0, -1, 1, 0, 0, width); break
              default: break
            }

            // draw image
            ctx.drawImage(img, 0, 0)

            // export base64
            callback2(canvas.toDataURL())
          }

          img.src = srcBase64
        }

        reader2.readAsDataURL(file)
      }

      var reader = new FileReader()
      reader.onload = function (e) {
        var view = new DataView(e.target.result)
        if (view.getUint16(0, false) !== 0xFFD8) {
          return callback(-2)
        }
        var length = view.byteLength
        var offset = 2
        while (offset < length) {
          var marker = view.getUint16(offset, false)
          offset += 2
          if (marker === 0xFFE1) {
            if (view.getUint32(offset += 2, false) !== 0x45786966) return callback(-1)
            var little = view.getUint16(offset += 6, false) === 0x4949
            offset += view.getUint32(offset + 4, little)
            var tags = view.getUint16(offset, little)
            offset += 2
            for (var i = 0; i < tags; i++) {
              if (view.getUint16(offset + (i * 12), little) === 0x0112) {
                return callback(view.getUint16(offset + (i * 12) + 8, little))
              }
            }
          } else if ((marker & 0xFF00) !== 0xFF00) {
            break
          } else {
            offset += view.getUint16(offset, false)
          }
        }
        return callback(-1)
      }
      reader.readAsArrayBuffer(file)
    },

    generateYearsToCurrentYear: function (yearStart) {
      let years = []
      let currentYear = new Date().getFullYear()
      for (let year = yearStart; year <= currentYear; year++) {
        years.push(year)
      }
      return years
    },
    getStaticMapUrl: function (latitude, longitude, width = 300, height = 300, zoom = 16) {
      return 'https://maps.googleapis.com/maps/api/staticmap?center=' + latitude + ',' + longitude + '&zoom=' + zoom + '&size=' + width + 'x' + height + '&maptype=roadmap&markers=color:red%7Clabel:%7C' + latitude + ',' + longitude + '&key=' + process.env.VUE_APP_GOOGLE_API_KEY
    },
    copyToClipbpard: function (text) {
      var textArea = document.createElement('textarea')
      textArea.value = text
      document.body.appendChild(textArea)
      textArea.select()
      document.execCommand('Copy')
      textArea.remove()
    },
    selectTextInElement: function (element) {
      var el = document.getElementById(element)
      var range = document.createRange()
      range.selectNodeContents(el)
      var sel = window.getSelection()
      sel.removeAllRanges()
      sel.addRange(range)
    },
    highlightKeywords: function (text, keywords, minKeywordLength = 3) {
      keywords = keywords.replace('  ', ' ')
      var keywordArray = uniq(keywords.split(' '))
      console.log(keywordArray)
      for (var i in keywordArray) {
        var keyword = keywordArray[i].trim()
        if (keyword.length >= minKeywordLength) {
          var pattern = new RegExp('(' + keyword + ')', 'gi')
          text = text.replace(pattern, '<mark>' + keyword + '</mark>')
        }
      }
      return text
    },
    br2nl: function (str) {
      return str.replace(/<br\s*\/?>/mg, '\n')
    },
    disableBottomDetector: function () {
      window.onscroll = () => {
      }
    },
    getUserProfile: function () {
      return JSON.parse(localStorage.getItem('user-profile'))
    },
    checkPermission: function (profile, permissionId, action) {
      if (profile && profile.permissions) {
        for (var i in profile.permissions) {
          if (this.profile.permissions[i].permissionId === permissionId) {
            if (this.profile.permissions[i]['is' + this.capitalize(action)] === '1') {
              return true
            }
          }
        }
      }
      return false
    },
    formatPrice: function (price, digit = 2, decimalSign = '.') {
      var formatter

      // if not-a-number
      if (isNaN(price)) {
        return 0
      }

      if (decimalSign === ',') {
        formatter = new Intl.NumberFormat('id-ID', {
          minimumFractionDigits: digit,
          maximumFractionDigits: digit
        })
      } else {
        formatter = new Intl.NumberFormat('us-US', {
          minimumFractionDigits: digit,
          maximumFractionDigits: digit
        })
      }

      return formatter.format(price)
    },
    roundToDecimal: function (num, decimal = 2) {
      var coefficient = Math.pow(10, decimal)
      return Math.round(num * coefficient) / coefficient
    },
    openDrawerForDesktop: function () {
      var width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth
      // var height = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight

      if (width > 960) {
        this.drawer = true
      }
    },
    monthName: function (month) {
      month = parseInt(month)
      for (let i in this.months) {
        if (this.months[i].value === month) {
          return this.months[i].name
        }
      }
      return false
    },
    showAlert: function (error) {
      if (error.response.status === 403) {
        window.alert('Sorry, you have no access to this function: ' + error.response.data.message)
      } else {
        window.alert(error.response.data.message)
      }
    },
    capitalize: function (value) {
      if (!value) return ''
      value = value.toString()
      value = value.toLowerCase()
      return value.charAt(0).toUpperCase() + value.slice(1)
    },
    deepCopy: function (o) {
      var output, v, key
      output = Array.isArray(o) ? [] : {}
      for (key in o) {
        v = o[key]
        output[key] = (typeof v === 'object') ? this.deepCopy(v) : v
      }
      return output
    },
    iso8601Format: function () {
      return 'YYYY-MM-DDTHH:mm:ssZ'
    },
    forceUpdate: function () {
      this.$forceUpdate()
    },
    delay: function (ms) {
      ms += new Date().getTime()
      while (new Date() < ms) {}
    },
    goBack: function () {
      router.go(-1)
    }
  },
  filters: {
    allCaps: function (string) {
      if (string !== null && typeof string !== 'undefined') {
        return string.toUpperCase()
      }
    },
    capitalize: function (value) {
      if (!value) return ''
      value = value.toString()
      value = value.toLowerCase()
      return value.charAt(0).toUpperCase() + value.slice(1)
    },
    truncate: function (string, value) {
      if (string.length > value) {
        return string.substring(0, value) + '...'
      }
      return string
    },
    formatDate: function (value, format, timezone = '') {
      moment.locale('us')
      if (typeof value !== 'undefined') {
        if (value.length > 0) {
          if (typeof timezone !== 'undefined' && timezone.length > 0) {
            if (timezone === '+00:00') {
              return moment(value, 'YYYY-MM-DDTHH:mm:ssZ').format(format) + ' (GMT)'
            } else {
              return moment(value, 'YYYY-MM-DDTHH:mm:ssZ').format(format) + ' (GMT ' + timezone + ')'
            }
          } else {
            return moment(value, 'YYYY-MM-DDTHH:mm:ssZ').format(format)
          }
        }
      }
      return ''
    }
  }
})

/*
  EventBus support these events
  - profileUpdated
*/
export const EventBus = new Vue()

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
